const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.emergent.localfoodhub.gqrfr3";

export default function PlayStoreBadge({ size = "md", className = "", href = PLAY_STORE_URL, testId = "play-store-btn" }) {
  const heightCls = size === "sm" ? "h-10" : size === "lg" ? "h-14" : "h-12";
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      aria-label="Get it on Google Play"
      className={`inline-block transition-transform hover:scale-[1.03] active:scale-95 ${className}`}
    >
      <img
        src="/google-play-badge.png"
        alt="Get it on Google Play"
        className={`${heightCls} w-auto`}
        loading="lazy"
      />
    </a>
  );
}
